import { changeUserPasswordUrl } from "@/api/system/user";
import { createFormItem } from "@/component-create/utils/create-form-item";
import { FormDialog } from "@/component-create/FormDialog";
import { FORM_ITEM } from "@/components/form/enums";
import { userBaseUrl } from "@/api/system/user"

let form: FormDialog | null = null

export function renderPassword(el: Element) {
  form = new FormDialog(
    el,
    { 
      items: items, 
      elFormProps: { 
        rules: rules 
      },
      saveUrl: changeUserPasswordUrl,
      loadUrl: userBaseUrl,
      saveMethods: 'put'
    }, 
    '修改密码'
  )
  return form
}

const items = [
  [
    createFormItem('新的密码', 'password', FORM_ITEM.INPUT, { clearable: true, maxlength: '20', showPassword: true })
  ],
  [
    createFormItem('重复密码', 'repassword', FORM_ITEM.INPUT, { clearable: true, maxlength: '20', showPassword: true })
  ],
]

const rules = {
  password: [{ required: true, message: '请输入新的密码', trigger: 'blur' },
    { min: 6, max: 20, message: '不能少于6个字符', trigger: 'blur' }],
  repassword: [{ required: true, message: '请再次输入新的密码', trigger: 'blur' },
    { min: 6, max: 20, message: '不能少于6个字符', trigger: 'blur' },
    { validator: (rule: any, value: any, callback: any) => {
      const user = form?.getFormDataNotValidate()
      if (value !== user.password) {
        callback(new Error('密码不一致'))
      } else {
        callback()
      }
    }, trigger: 'blur' }]
}